export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'accordion',
		label: 'Accordion',
		selector: '& .accordion'
	},
	{
		name: 'title',
		label: 'Title',
		selector: '& .title'
	},
	{
		name: 'content',
		label: 'Content',
		selector: '& .content'
	},
	{
		name: 'icon',
		label: 'Icon',
		selector: '& .icon'
	}
]